import React, { useEffect, useState } from 'react'
import PlaylistDetailsPage from './PlaylistDetailsPage'
import PropTypes from 'prop-types'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'

const PlaylistDetails = (props) => {
  const [source, setSource] = useState(null)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    setSource(String(urlParams.get('source')))
  }, [])

  return (
    <ThemeProvider theme={LightTheme}>
      <PlaylistDetailsPage
        playlistObj={props.playlist}
        userIsAuthor={props.userIsAuthor}
        signedIn={props.signedIn}
        source={source}
        membershipTier={props?.user?.membershipTier}
        totalItems={props?.totalItems}
      />
    </ThemeProvider>
  )
}

PlaylistDetails.propTypes = {
  playlist: PropTypes.string,
  signedIn: PropTypes.bool,
  userIsAuthor: PropTypes.bool,
  userIsAdmin: PropTypes.bool
}

export default PlaylistDetails
